export const isCustomDomain = !!window.config?.customDomain;
export const customDomainOrgSlug = window.config?.customDomain || null;
export const platformUrl = window.config?.platformUrl || null;
